import { Component, Inject, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'lz-message-html',
  template: `<div class="lz-user-messages-modal" id="lz-user-messages-modal">
  <div [innerHTML]="content.data"></div>
</div>
`,
  styles: [`.lz-pl-container{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container{width:732px;padding:0}}@media (min-width:1002px){.lz-pl-container{width:976px}}@media (min-width:1490px){.lz-pl-container{width:1440px}}.lz-pl-container-new{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container-new{width:732px;padding:0}}@media (min-width:1200px){.lz-pl-container-new{width:1200px}}@media (min-width:1490px){.lz-pl-container-new{width:1440px}}.modal-lg{width:900px}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}*{text-shadow:none!important}body,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0;font-weight:400}ol,ul{list-style:none}img{max-width:100%;height:auto;vertical-align:middle}.h1,.h2,.h3,.h4,.h5,.h6,button,h1,h2,h3,h4,h5,h6,input,p,textarea{font-family:inherit;font-size:inherit;font-weight:inherit}input:focus,textarea:focus{outline:0}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{line-height:1.1}fieldset{border:none}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane{max-width:95vw!important}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{max-height:95vh}::ng-deep .cdk-global-scrollblock{position:static!important;overflow:hidden;overflow-y:hidden}::ng-deep .cdk-global-scrollblock body{overflow:hidden}::ng-deep .cdk-overlay-container{z-index:1111}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-backdrop{z-index:1998}::ng-deep .cdk-overlay-container ::ng-deep .cdk-global-overlay-wrapper{z-index:1999}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{margin:0;padding:0!important;max-height:95vh;border-radius:0}@media (max-width:757px){::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{max-height:80vh}}::ng-deep .cdk-overlay-container .lz-user-message-modal{margin-top:10px}::ng-deep .cdk-overlay-container .lz-user-message-modal ::ng-deep .mat-dialog-container{margin:0;padding:0;max-height:95vh;height:auto;width:auto}.lz-user-messages-modal{position:relative;font-family:Geometria,Arial,sans-serif;padding:10px}.lz-user-messages-modal .close-icon{position:absolute;top:-15px;right:0;cursor:pointer;color:rgba(0,0,0,.36078431)}`],
  host: {
    '(click)': 'onClickInside($event)',
    '(document:click)': 'onClickOutside($event)',
  }
})

export class MessageHtmlComponent {

  public content: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef < MessageHtmlComponent > ,
    private elementRef: ElementRef,
    public sanitizer: DomSanitizer
  ) {
    if (data) {
      if (data.content && data.content.length > 0) {
        this.content.data = data.content.replace(new RegExp('ng-click', 'g'), '(click)');
        this.content.data = this.sanitizer.bypassSecurityTrustHtml(this.content.data);
      }
      if (data.options) {
        this.content.options = data.options;
      }
      if (data.callback) {
        this.content.callback = data.callback;
      }
    }
    this.content.dialogR = dialogRef;
  }

  onClickInside(event) {
    event.stopPropagation();
    if (event.target.hasAttribute('(click)') && event.target.getAttribute('(click)') === 'close()') {
      this.dialogRef.close(true);
      if (this.content.callback) {
        this.content.callback();
      }
    }
  }

  onClickOutside(event) {
    try {
      if (event.target != this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        this.dialogRef.close(true);
        if (this.content.callback) {
          this.content.callback();
        }
      }
    } catch (e) {}
  }

}
